import React, { FC, ReactNode } from 'react'

import { FlowLogger } from './createFlowLogger'
import { createFlowLoggerMock } from './createFlowLoggerMock'
import { FlowLoggerContext } from './FlowLoggerContext'

type FlowLoggerMockProviderParams = {
  flowLogger?: FlowLogger
  children?: ReactNode
}

export const FlowLoggerMockProvider: FC<FlowLoggerMockProviderParams> = ({
  flowLogger = createFlowLoggerMock(),
  children,
}) => {
  return <FlowLoggerContext.Provider value={flowLogger}>{children}</FlowLoggerContext.Provider>
}
